import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    backgroundColor: tokens.colorNeutralBackground3,
  },
  copyright: {
    fontSize: "12px",
    color: tokens.colorNeutralForeground2,
  },
  footerLeft: {
    justifyContent: "flex-start",
  },
});
